export default __webpack_public_path__ + "static/media/purpleCircle.5867d980.svg";